export function formatTokenCount(n: number): string {
  if (n < 10_000) return n.toLocaleString('en-US')

  if (n < 1_000_000) {
    const k = n / 1_000

    if (Number.isInteger(k)) return `${k}K`

    const rounded = Math.round(k * 10) / 10

    if (Number.isInteger(rounded)) return `${rounded.toLocaleString('en-US')}K`

    return `${k.toFixed(1)}K`
  }

  const m = n / 1_000_000

  if (Number.isInteger(m)) return `${m}M`

  const rounded = Math.round(m * 10) / 10

  if (Number.isInteger(rounded)) return `${rounded.toLocaleString('en-US')}M`

  return `${m.toFixed(1)}M`
}
